import { InlineStack } from '@shopify/polaris';
import React, { memo } from 'react';
import BoldText from '../BoldText';
import MediumText from '../MediumText';
import Switch from '../Switch';

interface ICustomSwitchLayout {
  title?: React.ReactNode;
  content?: string | React.ReactElement;
  enable?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  rightContent?: React.ReactNode;
}
function CustomSwitchLayout({ title, content, enable, onChange, disabled, rightContent }: ICustomSwitchLayout) {
  const handleChange = (value: boolean) => {
    if (onChange) onChange(value);
  };
  return (
    <InlineStack wrap={false} blockAlign="start" align={'space-between'} gap={'200'}>
      <div>
        <BoldText>{title}</BoldText>
        <div>
          <MediumText tone={'subdued'}>{content}</MediumText>
        </div>
      </div>
      <div style={{ minWidth: 'fit-content' }}>
        {disabled ? (
          rightContent && rightContent
        ) : (
          <Switch isActive={enable || false} onSwitch={handleChange} isLoading={disabled} />
        )}
      </div>
    </InlineStack>
  );
}

export default memo(CustomSwitchLayout);
